import request from '@/utils/seftRequest';

export function qryClusterInfo(data) {
  return request('/ding/lltoftth/qryGroupByClusterId', {
    method: 'POST',
    body: data,
  });
}

export function qryClusterNumberList(data) {
  return request('/ding/lltoftth/qryClusterByCondition', {
    method: 'POST',
    body: data,
  });
}

export function updateClusterDetails(data) {
  return request('/ding/lltoftth/updateFlagByFranchise', {
    method: 'POST',
    body: data,
  });
}
